<div
  class="cads-amount-detail-bit"
  [class.cads-amount-detail-bit--small]="isSmall()"
  [class.cads-amount-detail-bit--large]="isLarge()"
>
  <span class="cads-amount-detail-bit__value" [style.color]="valueColor()">{{ formattedValue() }}</span>
  @if (effectiveConfig().subtext?.trim(); as st) {
    <span class="cads-amount-detail-bit__subtext" [style.color]="subtextColor()">{{ st }}</span>
  }
</div>
